import React, { useCallback } from "react";

import { EventRow } from "./EventsTab.jsx";


import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { selectLatestEvent } from "../../store/eventsSlice.js";
import { sendAction } from "../../store/api.js";
import { RuntimeDisplay } from "./RuntimeDisplay.jsx";
import { useSiteConnected } from "../../store/connectionSlice.js";
import { useHwaddrFromRouter } from "../../store/sitesSlice.js";

export const StatusTab = _ => {
    const { hwaddr, networkId } = useParams();
    const latestEvent = useSelector(selectLatestEvent(hwaddr, networkId));
    const showRealtimeDisplay = useHwaddrFromRouter(useSiteConnected);

    const dispatch = useDispatch();
    const sendActionCb = useCallback((action, data) => dispatch(sendAction(hwaddr, networkId, action, data)), [hwaddr, networkId, dispatch])

    return <div>
        <div className="row">
            <div className="col-md-8 col-sm-8 col-xs-12 added-wordwrap">
                {latestEvent == null ? 
                    <div className="panel panel-info">
                        <div className="panel-body">
                            <p>No event found.</p>
                        </div>
                    </div>
                    :
                    <EventRow value={latestEvent} />}
            </div>
            <div id="actionButtons">
                <button className="btn btn-danger" onClick={() => sendActionCb("SOUNDER", "ALARM")} disabled={!showRealtimeDisplay}>Start Sounders</button>
                <button className="btn btn-danger pull-right" onClick={() => sendActionCb("SOUNDER", "OFF")} disabled={!showRealtimeDisplay}>Stop Sounders</button>
                <button className="btn btn-info" onClick={() => sendActionCb("MUTE", "NA")} disabled={!showRealtimeDisplay}>Silence Buzzer</button>
                <button className="btn btn-success pull-right" onClick={() => sendActionCb("RESET", "NA")} disabled={!showRealtimeDisplay}>Reset</button>
            </div>
        </div>
        {showRealtimeDisplay ? <RuntimeDisplay /> : null}
    </div>
}